/**
 * The sole publication switch for the staged security-information launch.
 *
 * Production is enabled following A7Y-2311 launch approval. This remains a
 * repository constant rather than a remotely mutable flag: a missing or
 * unfamiliar runtime must never expose a security claim.
 */
export const SECURITY_PRODUCTION_ENABLED = true;

export const SECURITY_PUBLIC_PATHS = [
  '/security',
  '/security/store-credentials',
  '/security/riskguard',
  '/security/soc2',
  '/security/iso27001',
  '/dpa',
  '/subprocessors',
  '/security/advisories',
] as const;

export type SecurityPublicPath = (typeof SECURITY_PUBLIC_PATHS)[number];
export type SecurityLaunchEnvironment = 'staging' | 'production' | 'unknown';

export function resolveSecurityLaunchEnvironment(value: unknown): SecurityLaunchEnvironment {
  if (value === 'staging') return 'staging';
  if (value === 'production') return 'production';
  return 'unknown';
}

export function resolveSecurityLaunchEnvironmentForHost(host: string): SecurityLaunchEnvironment {
  const hostname = host.split(':')[0]?.toLowerCase();
  if (hostname === 'www-staging.apptonomy.ai') return 'staging';
  if (hostname === 'www.apptonomy.ai') return 'production';
  return 'unknown';
}

export function isSecurityPublicationEnabled(environment: SecurityLaunchEnvironment): boolean {
  if (environment === 'staging') return true;
  if (environment === 'production') return SECURITY_PRODUCTION_ENABLED;
  return false;
}

export function isSecurityPublicPath(pathname: string): pathname is SecurityPublicPath {
  const normalized = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return (SECURITY_PUBLIC_PATHS as readonly string[]).includes(normalized);
}
